import { z } from 'zod';
import { FirebaseError } from '@firebase/app';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate } from 'react-router';
import { getErrorMessage, login } from '@/features/auth/functions/auth';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import { useEffect } from 'react';

const schema = z.object({
  email: z
    .string({ message: 'メールアドレスは必須です' })
    .email('メールアドレスの形式が正しくありません'),
  password: z
    .string({ message: 'パスワードは必須です' })
    .min(8, 'パスワードは8文字以上で入力してください'),
});

export function useLoginPage() {
  const navigate = useNavigate();

  const { user } = useAuth();
  const forms = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
    resolver: zodResolver(schema),
  });
  const { setError, clearErrors } = forms;

  const handleSubmit = forms.handleSubmit(async ({ email, password }) => {
    try {
      clearErrors('root');
      await login({
        email,
        password,
      });
      navigate('/tenants');
    } catch (e) {
      if (e instanceof FirebaseError) {
        setError('root', {
          type: 'manual',
          message: getErrorMessage(e),
        });
        return;
      }

      console.error(e);
      setError('root', {
        type: 'manual',
        message: 'エラーが発生しました',
      });
    }
  });

  useEffect(() => {
    if (user) {
      navigate('/tenants');
    }
  }, [user, navigate]);

  return {
    forms,
    handleSubmit,
  };
}
